import React from 'react';

const MedicationTable = ({ medications, isLoading, onLoadMore, hasMore }) => {
    if (isLoading && medications.length === 0) {
        return <div style={{ padding: '20px', textAlign: 'center', color: '#718096' }}>Loading medications...</div>;
    }

    if (!isLoading && medications.length === 0) {
        return <div style={{ padding: '20px', textAlign: 'center', color: '#718096' }}>No medications found.</div>;
    }

    return (
        <div style={{ backgroundColor: 'white', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                <thead>
                    <tr style={{ backgroundColor: '#edf2f7', color: '#4a5568', fontSize: '13px', textTransform: 'uppercase' }}>
                        <th style={{ padding: '15px 20px', fontWeight: '600' }}>Medicine Name</th>
                        <th style={{ padding: '15px 20px', fontWeight: '600' }}>Patient</th>
                        <th style={{ padding: '15px 20px', fontWeight: '600' }}>Date & Time</th>
                        <th style={{ padding: '15px 20px', fontWeight: '600' }}>Dosage</th>
                        <th style={{ padding: '15px 20px', fontWeight: '600' }}>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {medications.map((med, idx) => {
                        // Extract standard values safely
                        const name = med.medicineName || 'Unknown Medicine';
                        const patientName = med.userName || med.username || 'Unknown Patient';
                        
                        // Handle Flutter Timestamp format safely
                        let dateString = 'N/A';
                        if (med.date && med.date.toDate) {
                            dateString = med.date.toDate().toLocaleString([], { dateStyle: 'short', timeStyle: 'short' });
                        } else if (med.medicateDate) {
                            dateString = med.medicateDate;
                        }

                        // Just display the first timing dosage for the summary view
                        const dosage = med.timing && med.timing.length > 0 
                            ? `${med.timing[0].medicine_quantity || ''}` 
                            : 'N/A';
                            
                        // Calculate overall status for the row based on timing slots
                        let statusText = 'Pending';
                        let statusColor = '#d69e2e'; // yellow
                        let statusBg = '#feebc8';

                        if (med.discontinued) {
                            statusText = 'Discontinued';
                            statusColor = '#718096';
                            statusBg = '#edf2f7';
                        } else if (med.timing && med.timing.length > 0) {
                            // Simple logic: if any slot is given, mark administered
                            const anyGiven = med.timing.some(t => t.given === true);
                            const anyRefused = med.timing.some(t => t.administrationStatus && t.administrationStatus.includes('Refused'));
                            
                            if (anyGiven) {
                                statusText = 'Administered';
                                statusColor = '#38a169'; // green
                                statusBg = '#c6f6d5';
                            } else if (anyRefused) {
                                statusText = 'Refused';
                                statusColor = '#e53e3e'; // red
                                statusBg = '#fed7d7';
                            }
                        }

                        // Generate a truly unique key using the user ID, because the document ID might be the same
                        // across multiple users for the exact same medication on the exact same date.
                        const uniqueKey = med.userID ? `${med.id}-${med.userID}-${idx}` : `${med.id}-${idx}`;

                        return (
                            <tr key={uniqueKey} style={{ borderTop: '1px solid #e2e8f0', backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f7fafc' }}>
                                <td style={{ padding: '15px 20px', color: '#2d3748', fontWeight: '500' }}>{name}</td>
                                <td style={{ padding: '15px 20px', color: '#4a5568' }}>{patientName}</td>
                                <td style={{ padding: '15px 20px', color: '#4a5568', fontSize: '14px' }}>{dateString}</td>
                                <td style={{ padding: '15px 20px', color: '#4a5568' }}>{dosage}</td>
                                <td style={{ padding: '15px 20px' }}>
                                    <span style={{ 
                                        backgroundColor: statusBg, 
                                        color: statusColor, 
                                        padding: '4px 10px', 
                                        borderRadius: '12px', 
                                        fontSize: '12px', 
                                        fontWeight: 'bold' 
                                    }}>
                                        {statusText}
                                    </span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            
            {hasMore && (
                <div style={{ padding: '15px', textAlign: 'center', borderTop: '1px solid #e2e8f0' }}>
                    <button 
                        onClick={onLoadMore}
                        disabled={isLoading}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#ebf8ff',
                            color: '#3182ce',
                            border: '1px solid #bee3f8',
                            borderRadius: '6px',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            fontWeight: '600'
                        }}
                    >
                        {isLoading ? 'Loading...' : 'Load More'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default MedicationTable;
